export var colorsMapper = {
  green: 'primary.base',
  yellow: 'yellow.base',
  grey: 'secondary.light'
};